import React from 'react';
import Icon from 'components/AppIcon';

export default function PortfolioHeader({ portfolioData }) {
  const { totalValue, investedAmount, totalROI, todayGain, todayGainPercent } = portfolioData;
  const isPositive = totalROI >= 0;
  const isTodayPositive = todayGain >= 0;

  return (
    <div className="rounded-xl p-4 md:p-6 lg:p-8 mb-6"
      style={{ background: 'var(--color-primary)' }}>
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <p className="font-caption text-white/60 text-xs md:text-sm mb-1">Total Portfolio Value</p>
          <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl"
            style={{ color: 'var(--color-accent)' }}>
            ${totalValue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </h1>
          <div className="flex flex-wrap items-center gap-3 mt-2">
            <span className="font-caption text-white/70 text-xs md:text-sm">
              Invested: <span className="text-white font-medium">${investedAmount?.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
            </span>
            <span className={`flex items-center gap-1 font-caption text-xs md:text-sm font-semibold ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
              <Icon name={isPositive ? 'TrendingUp' : 'TrendingDown'} size={14} color="currentColor" />
              {isPositive ? '+' : ''}{totalROI?.toFixed(2)}% All Time
            </span>
          </div>
        </div>
        <div className="flex flex-row lg:flex-col gap-4 lg:gap-2 lg:items-end">
          <div className="bg-white/10 rounded-lg px-4 py-3">
            <p className="font-caption text-white/60 text-xs mb-1">Today&apos;s Gain/Loss</p>
            <p className={`font-data font-semibold text-base md:text-lg ${isTodayPositive ? 'text-emerald-400' : 'text-red-400'}`}>
              {isTodayPositive ? '+' : ''}${Math.abs(todayGain)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}
              <span className="text-xs ml-1">({isTodayPositive ? '+' : ''}{todayGainPercent?.toFixed(2)}%)</span>
            </p>
          </div>
          <div className="bg-white/10 rounded-lg px-4 py-3">
            <p className="font-caption text-white/60 text-xs mb-1">Total Gain/Loss</p>
            <p className={`font-data font-semibold text-base md:text-lg ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
              {isPositive ? '+' : ''}${Math.abs(totalValue - investedAmount)?.toLocaleString('en-US', { minimumFractionDigits: 2 })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}